import { SVGProps, Ref, forwardRef } from 'react';

export const HeartFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M16 8.782C10.182.476 0 3.936 0 11.936 0 18.603 9.333 24 16 28c6.667-4 16-9.397 16-16.064C32 4.34 21.818.476 16 8.782"
                fill="currentColor"
            />
        </g>
    </svg>
));
HeartFilledSize32Glyph.displayName = 'HeartFilledSize32Glyph';
